import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { motion, useInView } from "framer-motion";
import { usePadding } from "@/components/utils/Padding";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import "./styles.scss";

/* #META
 {
  "NAME": "SEO",
  "CLASSNAME": "seo-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const SEO = ({ data }) => {
  const seoModule = data?.seo_module_component;
  if (!seoModule) return null;

  const innerContent = seoModule?.inner_content;
  const paddingComponent = seoModule?.padding_component;
  const titleColor = innerContent?.title_color;
  const groups = innerContent?.list || [];

  const [openGroups, setOpenGroups] = useState({});
  const paddingStyle = usePadding(paddingComponent);

  const toggleGroup = (index) => {
    setOpenGroups((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const desktopListRef = useRef(null);
  const desktopListInView = useInView(desktopListRef, { once: true, threshold: 0.3 });

  //code to add animation when scroll on the list
  // const [scrolledLists, setScrolledLists] = useState({});
  // const listRefs = useRef({});

  // useEffect(() => {
  //   const listeners = [];
  //   const scrollTimeouts = {};

  //   groups.forEach((_, index) => {
  //     const el = listRefs.current[index];
  //     if (!el) return;

  //     const handleScroll = () => {
  //       setScrolledLists((prev) => ({
  //         ...prev,
  //         [index]: true,
  //       }));

  //       clearTimeout(scrollTimeouts[index]);

  //       scrollTimeouts[index] = setTimeout(() => {
  //         setScrolledLists((prev) => ({
  //           ...prev,
  //           [index]: false,
  //         }));
  //       }, 2000);
  //     };

  //     el.addEventListener("scroll", handleScroll);
  //     listeners.push({ el, handleScroll });
  //   });

  //   return () => {
  //     // Cleanup
  //     listeners.forEach(({ el, handleScroll }) => {
  //       el.removeEventListener("scroll", handleScroll);
  //     });
  //     Object.values(scrollTimeouts).forEach(clearTimeout);
  //   };
  // }, [groups]);

  return (
    <section className="seo-component" style={paddingStyle}>
      <div className="container-revamp">
        <div className="seo-lower-desktop">
          <div className="seo-lower-content" ref={desktopListRef}>
            {groups.map((group, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 50 }}
                className="seo-list relative"
                animate={desktopListInView ? { opacity: 1, x: 0 } : {}}
                transition={{ delay: index * 0.4, duration: 0.5, ease: "easeOut" }}
              >
                {group?.title && (
                  <h4 className={`list-title list-title--${titleColor}`}>{group.title}</h4>
                )}
                {group?.items && group.items.length > 0 && (
                  <div className="list-container mt-8">
                    {/* {scrolledLists[index] && (
                      <>
                        <div className="fade-top" />
                        <div className="fade-bottom" />
                      </>
                    )} */}
                    <ul className="list-items max-h-[328px] overflow-y-auto">
                      {group.items.map((item, i) => (
                        <li key={`${group.title}-${i}`}>
                          {item?.single_item_link?.url ? (
                            <a href={item.single_item_link.url}>{item?.single_item}</a>
                          ) : (
                            <span>{item?.single_item}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        <div className="seo-lower-mobile">
          <div className="seo-lower-content">
            {groups.map((group, index) => (
              <div key={index} className="seo-list-group">
                <div className="seo-list-group-header">
                  <h4 className={`seo-list-group-title list-title--${titleColor}`}>
                    {group?.title}
                  </h4>
                  <button onClick={() => toggleGroup(index)} className="seo-toggle-button">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      style={{
                        marginLeft: "8px",
                        transition: "transform 0.3s",
                        transform: openGroups[index] ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    >
                      <path
                        d="M6.3335 9.5L12.3335 15.5L18.3335 9.5"
                        stroke="#FDE5AC"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <SlideDown>
                  {openGroups[index] && (
                    <div className="seo-list-group-content">
                      <ul>
                        {group?.items?.map((item, i) => (
                          <li key={`${group.title}-${i}`}>
                            <a href={item?.single_item_link?.url}>{item?.single_item}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </SlideDown>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

SEO.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    seo_module_component: PropTypes.shape({
      padding_component: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
      inner_content: PropTypes.shape({
        title_color: PropTypes.string,
        list: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            items: PropTypes.arrayOf(
              PropTypes.shape({
                single_item: PropTypes.string,
                single_item_link: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
              })
            ),
          })
        ),
      }),
    }),
  }),
};

export default SEO;
